import { Controller } from "stimulus";

export default class extends Controller {
  declare modalTarget: HTMLElement;
  declare hasContainerTarget: boolean;
  declare containerTarget: HTMLElement;
  static targets = ["modal", "container"];

  declare defaultOpenedValue: boolean;
  declare shouldDismissOnClickOutsideValue: boolean;
  static values = {
    defaultOpened: {
      type: Boolean,
      default: false
    },
    shouldDismissOnClickOutside: {
      type: Boolean,
      default: false
    }
  };

  private originalPosition = "initial";
  private originalZIndex = "initial";
  onOpenCallbacks: (() => void)[] = [];
  onCloseCallbacks: (() => void)[] = [];

  connect(): void {
    this.modalTarget.hidden = true;
    this.originalPosition = this.modalTarget.style.position ?? "initial";
    this.originalZIndex = this.modalTarget.style.zIndex ?? "initial";

    if (this.defaultOpenedValue) {
      this.showModal();
    }

    if (this.shouldDismissOnClickOutsideValue && this.hasContainerTarget) {
      this.dismissOnClickOutside = this.dismissOnClickOutside.bind(this);
      this.modalTarget.addEventListener("click", this.dismissOnClickOutside);
    }
  }

  disconnect(): void {
    this.modalTarget.removeEventListener("click", this.dismissOnClickOutside);
  }

  registerCallbacks(opts: { onOpen: () => void; onClose: () => void }) {
    this.onOpenCallbacks.push(opts.onOpen);
    this.onCloseCallbacks.push(opts.onClose);
  }

  showModal() {
    this.modalTarget.hidden = false;
    this.modalTarget.style.position = "fixed";
    this.modalTarget.style.zIndex = "50";
    this.onOpenCallbacks.forEach((cb) => cb());
  }

  dismissModal() {
    this.modalTarget.hidden = true;
    this.modalTarget.style.position = this.originalPosition;
    this.modalTarget.style.zIndex = this.originalZIndex;
    this.onCloseCallbacks.forEach((cb) => cb());
  }

  dismissOnClickOutside(event: MouseEvent) {
    if (this.modalTarget.hidden) {
      return;
    }

    if (event.target instanceof window.Node
      && this.hasContainerTarget
      && !this.containerTarget.contains(event.target)) {
      this.dismissModal();
    }
  }
}
